import {
  HttpEvent,
  HttpHandlerFn,
  HttpHeaders,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, throwError } from 'rxjs';
import { AuthEventService } from '../services/auth-event.service';
import { ReturnUrlService } from '../services/return-url.service';

export function tokenInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const token = localStorage.getItem('token');
  const router = inject(Router);
  const authEventService = inject(AuthEventService);
  const returnUrlService = inject(ReturnUrlService);

  if (!token) {
    return next(req);
  }

  let headers = new HttpHeaders({
    Accept: 'application/json',
    Authorization: `Bearer ${token}`,
  });
  if (req.headers.has('x-validate-only')) {
    headers = headers.set('x-validate-only', 'true');
  }
  const newReq = req.clone({
    headers,
  });

  return next(newReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        // Token is invalid or expired
        localStorage.removeItem('token');

        // Trigger force logout event to clear user state
        authEventService.triggerForceLogout();

        // Store current URL as return URL before redirecting
        const urlToStore = window.location.pathname + window.location.search;
        returnUrlService.setReturnUrl(urlToStore);

        // Navigate to login page
        router.navigate(['/auth/login']);
      }
      return throwError(() => error);
    })
  );
}
